var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "8px",
    viewBox: "0 0 14 8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Actions / Navigation / chevron--down / 20") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Current-Iteration",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Syg_patient_therapy_expanded",
    transform: "translate(-1183.000000, -842.000000)",
    fill: "#0043CE"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SOC",
    transform: "translate(112.000000, 472.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-More",
    transform: "translate(0.000000, 336.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-more",
    transform: "translate(971.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Actions-/-Navigation-/-chevron--down-/-20",
    transform: "translate(97.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill",
    points: "10 13.75 3.75 7.5 4.625 6.625 10 12 15.375 6.625 16.25 7.5"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron--down.6b9bc7f7.svg";
export { ForwardRef as ReactComponent };